import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';

// Layouts
import MainLayout from './layouts/MainLayout';
import AdminLayout from './layouts/AdminLayout';

// Reservation Pages
import ReservationPage from './pages/ReservationPage';
import ManageReservationPage from './pages/ManageReservationPage';

// Admin Pages
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AdminReservationsPage from './pages/AdminReservationsPage';
import AdminServicesPage from './pages/AdminServicesPage';
import AdminBlockedTimesPage from './pages/AdminBlockedTimesPage';
import AdminUsersPage from './pages/AdminUsersPage';
import AdminSettingsPage from './pages/AdminSettingsPage';
import AdminGalleryPage from './pages/AdminGalleryPage';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const adminUser = localStorage.getItem('admin_user');
  
  if (!adminUser) {
    return <Navigate to="/admin/login" replace />;
  }
  
  return children;
};

const RootRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const host = window.location.hostname || '';
    if (host.startsWith('admin.')) {
      navigate('/admin/login', { replace: true });
      return;
    }
    navigate('/rezervacia', { replace: true });
  }, [navigate]);

  return null;
};

const TitleManager = () => {
  const location = useLocation();

  const getTitle = (path) => {
    const titles = {
      '/': 'Rezervácia – ServisML',
      '/rezervacia': 'Rezervácia – ServisML',
      '/moja-rezervacia': 'Moja rezervácia – ServisML',
      '/admin': 'Administrácia – ServisML',
      '/admin/login': 'Prihlásenie – ServisML',
      '/admin/dashboard': 'Váš prehľad – ServisML',
      '/admin/reservations': 'Správa rezervácií – ServisML',
      '/admin/services': 'Ponúkané služby – ServisML',
      '/admin/blocked-times': 'Blokované časy – ServisML',
      '/admin/users': 'Administrátori – ServisML',
      '/admin/settings': 'Nastavenia – ServisML',
      '/admin/gallery': 'Galéria – ServisML',
    };

    return titles[path] || 'ServisML';
  };

  useEffect(() => {
    document.title = getTitle(location.pathname);
  }, [location.pathname]);

  return null;
};

function App() {
  return (
    <BrowserRouter>
      <TitleManager />
      <Routes>
        {/* Reservation Routes */}
        <Route path="/" element={<MainLayout />}>
          <Route index element={<RootRedirect />} />
          <Route path="rezervacia" element={<ReservationPage />} />
          <Route path="moja-rezervacia" element={<ManageReservationPage />} />
          <Route path="*" element={<Navigate to="/rezervacia" replace />} />
        </Route>

        {/* Admin Routes */}
        <Route path="/admin/login" element={<AdminLoginPage />} />
        
        <Route path="/admin" element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }>
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<AdminDashboardPage />} />
          <Route path="reservations" element={<AdminReservationsPage />} />
          <Route path="services" element={<AdminServicesPage />} />
          <Route path="blocked-times" element={<AdminBlockedTimesPage />} />
          <Route path="users" element={<AdminUsersPage />} />
          <Route path="gallery" element={<AdminGalleryPage />} />
          <Route path="settings" element={<AdminSettingsPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
